import React, { useRef } from 'react';
import { convertProxyImgUrl } from 'client/utils/getProxyImgUrl';
import LazyLoadImg from 'client/components/LazyLoadImg';

export default function ResponsiveUgcProxyPicture({
    src = '',
    alt,
    onLoad = () => {},
    breakPointConfigs = {},
    enableLazyLoad = false,
    ...restProps
}) {
    const { normal = {}, ...rest } = breakPointConfigs;
    const mediaConfigs = Object.entries(rest);
    const isError = useRef(false);
    const img = (
        <LazyLoadImg
            enableLazyLoad={enableLazyLoad}
            src={convertProxyImgUrl({
                url: src,
                ...normal
            })}
            onError={e => {
                if (!isError.current) {
                    e.target.src = src;
                    isError.current = true;
                }
            }}
            alt={alt}
            onLoad={onLoad}
            {...restProps}
        />
    );
    if (mediaConfigs.length > 0) {
        const sources = mediaConfigs.map(([breakpoint, config = {}]) => (
            <source
                key={breakpoint}
                media={`(max-width: ${breakpoint}px)`}
                srcSet={convertProxyImgUrl({
                    url: src,
                    ...config
                })}
            />
        ));
        return (
            <picture>
                {sources}
                {img}
            </picture>
        );
    } else {
        return img;
    }
}
